export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 2,
				text: "Der Dozent/Die Dozentin war fachlich kompetent.",
			},
			{
				id: 3,
				text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 4,
				text: "Das Thema des Online-Moduls interessiert mich.",
			},
			{
				id: 5,
				text: "Das Thema des Online-Moduls hatte einen klaren Praxisbezug.",
			},
			{
				id: 6,
				text: "Das Thema des Online-Moduls knüpfte gut an meine Vorerfahrung (Studium/Beruf) an.",
			},
			{
				id: 7,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 8,
				text: "Der inhaltliche Aufbau des Online-Moduls war logisch/nachvollziehbar.",
			},
			{
				id: 9,
				text: "Die Inhalte des Online-Moduls waren gut über die gesamte Dauer verteilt.",
			},
			{
				id: 10,
				text: "Die Lernmaterialien waren gut strukturiert und logisch gegliedert.",
			},
			{
				id: 11,
				text: "Das Niveau der Lernmaterialien war angemessen.",
			},
			{
				id: 12,
				text: "Die Lernmaterialien waren interessant und abwechslungsreich aufgebaut.",
			},
			{
				id: 13,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 14,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 15,
				text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
			},
			{
				id: 16,
				text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
			},
			{
				id: 17,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 18,
				text: "Insgesamt waren die digitalen Elemente des Online-Moduls gut.",
			},
			{
				id: 19,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 20,
				text: "Die Schwere des Stoffes war...",
			},
			{
				id: 21,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 22,
				text: "Die Anforderungen des Online-Moduls waren...",
			},
			{
				id: 23,
				text: "Der Zeitaufwand für das Online-Modul insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 24,
				text: "Das Online-Moduls war insgesamt gut in meinen Alltag integrierbar.",
			},
			{
				id: 25,
				text: "Meine Erwartungen an das Online-Modul wurden erfüllt.",
			},
			{
				id: 26,
				text: "Ich würde das Online-Modul weiterempfehlen.",
			},
		],
	},
	{
		type: "age",
		id: 4,
		items: [
			{
				id: 27,
				text: "Alter: ",
			},
		],
	},
	{
		type: "text",
		id: 5,
		items: [
			{
				id: 28,
				type: "small",
				text: "Semesteranzahl:",
			},
			{
				id: 29,
				text: "Besonders gut fand ich:",
			},
			{
				id: 30,
				text: "Verbesserungsvorschläge:",
			},
		],
	},
];
